import { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import LoginModal from '../login/LoginModal';
import { getLoginType, useUserStore, getUserData } from '../../store';
import { getUserLoginStatus } from '../../services';
import { reportPageView } from '../../services/reportLog';
import './index.scss';

// 箭头 SVG 路径
const arrowPath = "M16.8928 3.20001C9.83552 3.20001 4.0928 8.94209 4.0928 16C4.0928 23.0579 9.83552 28.8 16.8928 28.8C23.9507 28.8 29.6928 23.0579 29.6928 16C29.6928 8.94209 23.9507 3.20001 16.8928 3.20001ZM21.8566 18.2176L17.8381 21.6301C17.5742 21.8546 17.239 21.9779 16.8925 21.9779C16.546 21.9779 16.2108 21.8546 15.9469 21.6301L11.9283 18.2176C11.6462 17.9631 11.4744 17.6088 11.4491 17.2297C11.4239 16.8506 11.5474 16.4766 11.7933 16.187C12.0392 15.8974 12.3882 15.715 12.7663 15.6784C13.1445 15.6418 13.522 15.754 13.8189 15.9911L15.4323 17.3613V11.4823C15.4323 11.095 15.5862 10.7236 15.86 10.4498C16.1338 10.1759 16.5052 10.0221 16.8925 10.0221C17.2797 10.0221 17.6511 10.1759 17.925 10.4498C18.1988 10.7236 18.3526 11.095 18.3526 11.4823V17.3613L19.9661 15.9911C20.2616 15.7409 20.6442 15.618 21.0302 15.6495C21.4161 15.6809 21.7738 15.864 22.025 16.1587C22.5466 16.7738 22.471 17.6947 21.8566 18.2176Z";

export default function Home() {
  const [isLoginOpen, setIsLoginOpen] = useState(false);
  const navigate = useNavigate();
  const { isLoggedIn, isRegistered, setRegistered } = useUserStore();

  useEffect(() => {
    reportPageView('content_0003');
  }, []);

  const handleGetStarted = async () => {
    if (isLoggedIn()) {
      // 使用接口判断一下是否已注册
      const data: any = await getUserLoginStatus({
        uid: getUserData()?.id || '',
        loginType: getLoginType() || 1,
      });
      if (data?.isRegistered) {
        setRegistered(true);
        navigate('/app/dashboard');
      } else {
        setRegistered(false);
        navigate('/onboarding/name');
      }
    } else {
      setIsLoginOpen(true);
    }
  };

  const handleSignIn = () => {
    setIsLoginOpen(true);
  };

  const handleLoginClose = () => {
    setIsLoginOpen(false);
  };

  const handleLoginSuccess = () => {
    setIsLoginOpen(false);
    if (isRegistered()) {
      navigate('/app/dashboard');
    } else {
      navigate('/onboarding/name');
    }
  };

  return (
    <div className="home-page">
      {/* Header */}
      <header className="home-header">
        <div className="home-header-content">
          {/* Logo */}
          <div className="home-logo">
            <img
                className="logo-text"
                src="https://akoss.bangcdn.net/fe/leftLogo.svg"
                alt="Phoenix Music for Artists"
              />
          </div>

          {/* Sign in Button */}
          <button className="sign-in-button" onClick={handleSignIn}>
            Sign in
          </button>
        </div>
      </header>

      {/* Hero Section */}
      <section className="home-hero">
        <div className="hero-content">
          <div className="hero-text">
            <h1 className="hero-title">Get Heard by Millions.</h1>
            <p className="hero-subtitle">
              The ultimate launchpad for emerging artists. Take your music from the studio to the spotlight.
            </p>
          </div>
          <button className="get-started-button" onClick={handleGetStarted}>
            <span>Get Started</span>
            <div className="arrow-icon">
              <svg viewBox="0 0 32 32" fill="none">
                <path d={arrowPath} fill="black" transform="rotate(-90 16 16)" />
              </svg>
            </div>
          </button>
        </div>
      </section>

      {/* Login Modal */}
      {isLoginOpen && (
        <LoginModal 
          onClose={handleLoginClose}
          onLoginSuccess={handleLoginSuccess}
        />
      )}
    </div>
  );
}
